import { render, staticRenderFns } from "./EvolutionModal.vue?vue&type=template&id=64089723&scoped=true"
import script from "./EvolutionModal.vue?vue&type=script&lang=js"
export * from "./EvolutionModal.vue?vue&type=script&lang=js"
import style0 from "./EvolutionModal.vue?vue&type=style&index=0&id=64089723&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64089723",
  null
  
)

export default component.exports